<irembogov-date-time-picker
  [formControl]="formControl"
  ngDefaultControl
  [maxDate]="field.props['maxDate']"
  [addRemoveTimeMinDate]="field.props['addRemoveTimeMinDate']"
  [addRemoveTimeMaxDate]="field.props['addRemoveTimeMaxDate']"
  [allowedDaysOfTheWeek]="field.props['allowedDaysOfTheWeek']"
  [requiredField]="this.field.props.required ?? false"
  [minDate]="field.props['minDate']"
  [placeholder]="field.props['placeholder']"
  [dateFormat]="field.props['dateFormat']"
  [eventCode]="field.props['eventCode']"
  [eventDatesMaxSize]="field.props['eventDatesMaxSize']"
  [delimeter]="field.props['delimeter'] ?? '-'"
  [labelForId]="field.key"
  [endHour]="field.props['endHour']"
  [startHour]="field.props['startHour']"
  [interval]="field.props['interval']"></irembogov-date-time-picker>
